import LoginProfileLoader from '@/auth/LoginProfileLoader';
import LoginUserPagePrivLoader from '@/auth/LoginUserPagePrivLoader';
import CustomThemeWrapper from '@/components/CustomThemeWrapper';
import { SITE_META } from '@/constants';
import { LightboxImageViewEventHandler } from '@/custom-events';
import StoreProvider from '@/store/StoreProvider';
import theme from '@/theme';
import { CssBaseline, ThemeProvider } from '@mui/material';
import { AppCacheProvider } from '@mui/material-nextjs/v15-pagesRouter';
import type { AppProps as NextAppProps } from 'next/app';
import Head from 'next/head';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import * as timeago from 'timeago.js';
import ko from 'timeago.js/lib/lang/ko';

timeago.register('ko', ko);

export default function MyApp(props: NextAppProps) {
  const { Component, pageProps } = props;

  return (
    <AppCacheProvider {...props}>
      <Head>
        {/* <meta name="viewport" content="initial-scale=1, width=device-width" /> */}
        <title>경영지원관리시스템</title>
        <link rel="icon" href="/images/clover-logo.png" />
        <meta charSet="utf-8" />
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0,
               maximum-scale=1.0, user-scalable=no"
        />
        <meta name="description" content={SITE_META.description} />
        <meta name="title" content={SITE_META.title} />
        <meta property="og:type" content="website" />
        <meta property="og:title" content={SITE_META.title} />
        <meta property="og:description" content={SITE_META.description} />
        <meta property="og:image" content={SITE_META.image} />
        <meta property="og:url" content={SITE_META.url} />
        {/* 맑음 고딕 폰트 font-family: 'Malgun Gothic', 'Helvetica', 'Arial', 'sans-serif'; */}
        {/* <style jsx global>{`
          html {
            font-family: ${notoSansKR.style?.fontFamily};
          }
        `}</style> */}
      </Head>
      <StoreProvider rootStoreInitialState={undefined}>
        <ThemeProvider theme={theme}>
          <CustomThemeWrapper>
            <CssBaseline />
            <Component {...pageProps} />
            <LightboxImageViewEventHandler />
            <LoginProfileLoader />
            <LoginUserPagePrivLoader />
            <ToastContainer
              position="top-center"
              hideProgressBar
              autoClose={2000}
              pauseOnHover
              draggable
            />
          </CustomThemeWrapper>
        </ThemeProvider>
      </StoreProvider>
    </AppCacheProvider>
  );
}
